import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getOutsideURL } from '../../utils';
import { CustomLinkBookIcon } from '../CustomLinkBookIcon';
import { IconActionActionCompare } from '../ui/IconActionActionCompare';
import cn from 'classnames';
import styles from './index.module.scss';
import { ExtendedBaseRouteProps } from '../../types';

type Props = Omit<ExtendedBaseRouteProps, "pageRoute">;

const goToSearchClasses = cn({
    [styles.goToSearchLink]: true,
    'analytics-go-to-search': true,
});

export const NoItemsComponent: React.FC<Props> = ({
    contextRoot,
    countryCode,
    languageCode,
    isPublic
}) => (
    <div className={styles.headingContainer}>
        <div className={styles.noResultsFoundContainer}>
            <IconActionActionCompare />
            <FormattedMessage
                id="comparison.label.noItems"
                defaultMessage="No items to compare"
            >
                {txt => <h4 className={styles.noItemsHeading}>{txt}</h4>}
            </FormattedMessage>

            <FormattedMessage
                id="comparison.label.howToUse"
                defaultMessage="Please, use checkboxes on the cards or special options on product pages to add items to the product comparison. "
            >
                {txt => <span className={styles.noItemsHeading}>{txt}</span>}
            </FormattedMessage>

            <FormattedMessage
                id="comparison.label.seeCatalog"
                defaultMessage="See the catalog"
            >
                {txt => (
                    <CustomLinkBookIcon
                        href={getOutsideURL({
                            baseURL: contextRoot,
                            pageRoute: 'all-products',
                            countryCode,
                            languageCode,
                            isPublic
                        })}
                        className={goToSearchClasses}
                        text={`${txt}`}
                    />
                )}
            </FormattedMessage>
        </div>
    </div>
); 
